<template>
  <div>
    <h1>Login</h1>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style scoped>
</style>
